import { render, staticRenderFns } from "./FeedEdit.vue?vue&type=template&id=658244b1&scoped=true&"
import script from "./FeedEdit.vue?vue&type=script&lang=js&"
export * from "./FeedEdit.vue?vue&type=script&lang=js&"
import style0 from "./FeedEdit.vue?vue&type=style&index=0&id=658244b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658244b1",
  null
  
)

export default component.exports